import ActivationComponent from "@/PageComponents/Activation/ActivationComponent";
import { createFileRoute } from '@tanstack/react-router'



const Activate = () => {
    return <ActivationComponent />;
};

export default Activate;

export const Route = createFileRoute('/activate')({ component: Activate })
